import { CustomerContact } from "../entities/customer-contact.entity";

export type CustomersState = {
  contacts: CustomerContact[];
  loading: boolean;
  saving: boolean;
  error: string | null;
  isEditing: boolean;
  selectedIds: number[];
  showAlert: boolean;
  showDeleteConfirmation: boolean;
};

export const initialCustomersState: CustomersState = {
  contacts: [],
  loading: false,
  saving: false,
  error: null,
  isEditing: false,
  selectedIds: [],
  showAlert: true,
  showDeleteConfirmation: false,
};
